module.exports = __webpack_public_path__ + "img/life-insurance-lifebuoy.d9a1e7c.png";